import { ReactElement } from 'react'
import { Space } from 'antd'

const FacebookLogo = (): ReactElement => (
  <a
    href="https://www.facebook.com/bonlook.eyewear"
    target="_blank"
    title="Facebook Link"
    rel="noreferrer"
  >
    <svg
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4057 0.004161L7.81221 0C4.89847 0 3.01548 1.9319 3.01548 4.92203V7.19141H0.407807C0.182473 7.19141 0 7.37409 0 7.59942V10.8875C0 11.1128 0.182681 11.2953 0.407807 11.2953H3.01548V19.5922C3.01548 19.8175 3.19796 20 3.42329 20H6.82556C7.0509 20 7.23337 19.8173 7.23337 19.5922V11.2953H10.2823C10.5077 11.2953 10.6901 11.1128 10.6901 10.8875L10.6914 7.59942C10.6914 7.49123 10.6483 7.38762 10.5719 7.31105C10.4956 7.23449 10.3916 7.19141 10.2834 7.19141H7.23337V5.26762C7.23337 4.34297 7.45371 3.87357 8.6582 3.87357L10.4053 3.87296C10.6304 3.87296 10.8129 3.69028 10.8129 3.46515V0.411975C10.8129 0.187052 10.6306 0.004577 10.4057 0.004161Z"
        fill="#ABABB3"
      ></path>
    </svg>
  </a>
)

const InstagramLogo = (): ReactElement => (
  <a
    href="https://www.instagram.com/bonlook/"
    target="_blank"
    title="Instagram Link"
    rel="noreferrer"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4C5.79086 4 4 5.79086 4 7.99999V17C4 19.2091 5.79086 21 8 21H17C19.2091 21 21 19.2091 21 17V7.99999C21 5.79086 19.2091 4 17 4H8ZM12.5 17.6944C15.3688 17.6944 17.6944 15.3688 17.6944 12.5C17.6944 9.63119 15.3688 7.30556 12.5 7.30556C9.63119 7.30556 7.30556 9.63119 7.30556 12.5C7.30556 15.3688 9.63119 17.6944 12.5 17.6944ZM19.1054 6.95186C19.1054 7.53892 18.6295 8.01482 18.0424 8.01482C17.4554 8.01482 16.9795 7.53892 16.9795 6.95186C16.9795 6.3648 17.4554 5.88889 18.0424 5.88889C18.6295 5.88889 19.1054 6.3648 19.1054 6.95186ZM12.5001 16.2779C14.5865 16.2779 16.2779 14.5865 16.2779 12.5001C16.2779 10.4136 14.5865 8.72217 12.5001 8.72217C10.4136 8.72217 8.72217 10.4136 8.72217 12.5001C8.72217 14.5865 10.4136 16.2779 12.5001 16.2779Z"
        fill="#ABABB3"
      ></path>
    </svg>
  </a>
)

const TwitterLogo = (): ReactElement => (
  <a
    href="https://twitter.com/BonLook"
    target="_blank"
    title="Twitter Link"
    rel="noreferrer"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9999 5.11433C22.1902 5.47313 21.3214 5.71646 20.4085 5.82509C21.3406 5.26693 22.0541 4.38161 22.3923 3.32992C21.518 3.84682 20.5529 4.22215 19.5245 4.42561C18.7011 3.54716 17.5298 3 16.2307 3C13.7383 3 11.7174 5.02087 11.7174 7.5119C11.7174 7.8652 11.7573 8.21026 11.8343 8.54022C8.084 8.35186 4.75852 6.55508 2.53281 3.82482C2.14375 4.49021 1.92242 5.26553 1.92242 6.09315C1.92242 7.659 2.71978 9.04061 3.92956 9.84893C3.18994 9.8242 2.49431 9.62074 1.88532 9.28254V9.33891C1.88532 11.5248 3.44154 13.349 5.50501 13.7642C5.12694 13.866 4.72828 13.9223 4.31586 13.9223C4.02443 13.9223 3.7426 13.8935 3.46627 13.8385C4.04089 15.6325 5.7071 16.9371 7.68124 16.9729C6.1374 18.1827 4.19076 18.9017 2.07642 18.9017C1.71212 18.9017 1.35329 18.8797 1 18.8398C2.99751 20.1224 5.36894 20.8703 7.91771 20.8703C16.2197 20.8703 20.7578 13.9938 20.7578 8.0302L20.7426 7.44594C21.6293 6.81351 22.3964 6.01892 22.9999 5.11433Z"
        fill="#ABABB3"
      ></path>
    </svg>
  </a>
)

const Pinterest = (): ReactElement => (
  <a
    href="https://www.pinterest.ca/bonlook/"
    target="_blank"
    title="Pinterest Link"
    rel="noreferrer"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0299 12.015C21.0299 16.9938 16.9938 21.03 12.015 21.03C7.03614 21.03 3 16.9938 3 12.015C3 7.03614 7.03614 3 12.015 3C16.9938 3 21.0299 7.03614 21.0299 12.015ZM11.6035 14.597C11.942 14.8318 12.231 15.0322 12.7427 15.0718C15.2573 15.2659 16.6618 12.5619 16.319 10.0651C16.0144 7.8529 13.807 6.72607 11.4552 6.9893C9.59554 7.19757 7.74154 8.70252 7.66424 10.8519C7.61635 12.165 7.98886 13.1499 9.23766 13.4265C9.59299 12.7993 9.40717 12.493 9.20571 12.1609C9.10003 11.9867 8.99004 11.8054 8.95161 11.567C8.49314 8.73258 12.2215 6.79758 14.1727 8.77757C15.5233 10.149 14.6343 14.3653 12.4566 13.9276C11.3697 13.7091 11.6928 12.693 12.016 11.6767C12.313 10.7426 12.6101 9.80825 11.8126 9.49285C10.4595 8.95723 9.74081 11.1309 10.3823 12.2108C10.2832 12.7 10.154 13.1817 10.0234 13.6685C9.65809 15.0299 9.28211 16.4313 9.52419 18.1472C10.5875 17.3754 10.9465 15.8979 11.2403 14.3566C11.3735 14.4375 11.4912 14.5191 11.6035 14.597Z"
        fill="#ABABB3"
      ></path>
    </svg>
  </a>
)

const SocialMediaBonLook = (): ReactElement => (
  <Space size="middle">
    <FacebookLogo />
    <InstagramLogo />
    <TwitterLogo />
    <Pinterest />
  </Space>
)

export {
  FacebookLogo,
  InstagramLogo,
  Pinterest,
  SocialMediaBonLook,
  TwitterLogo,
}
